import { render, staticRenderFns } from "./PacFintoc.vue?vue&type=template&id=58b05468&scoped=true&"
import script from "./PacFintoc.vue?vue&type=script&lang=js&"
export * from "./PacFintoc.vue?vue&type=script&lang=js&"
import style0 from "./PacFintoc.vue?vue&type=style&index=0&id=58b05468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b05468",
  null
  
)

export default component.exports